import { render } from "./PhoneBook.vue?vue&type=template&id=68f02fa3"
import script from "./PhoneBook.vue?vue&type=script&lang=js"
export * from "./PhoneBook.vue?vue&type=script&lang=js"
script.render = render

export default script